import StatusScreen from "@/components/status-screen";
import { createFileRoute } from "@tanstack/react-router";
import { X } from "lucide-react";

export const Route = createFileRoute("/_private/billing/cancel")({
  component: BillingCancel,
});

function BillingCancel() {
  return (
    <StatusScreen
      icon={<X />}
      iconWrapperClassName="text-red-500 bg-red-50 dark:bg-red-900/20 dark:text-red-400"
      title="Payment Cancelled"
      description="Your payment has been cancelled. Please try again."
      variant="link-button"
      buttonText="View Billing Details"
      buttonLink="/billing"
      wrapperClass="min-h-[calc(100vh-150px)] flex justify-center items-center w-full"
    />
  );
}

// <div className="flex flex-col items-center justify-center w-full">
//   <Card className="border-none shadow-none bg-transparent max-w-md mx-auto">
//     <CardHeader className="space-y-4">
//       <div
//         className={cn(
//           "flex items-center justify-center w-16 h-16 rounded-full mx-auto [&>svg]:size-8",
//           "bg-gray-100 [&>svg]:text-gray-500"
//         )}
//       >
//         <X />
//       </div>
//       <CardTitle className="text-2xl text-center text-foreground">
//         Payment Cancelled
//       </CardTitle>
//       <CardDescription className="text-muted-foreground text-center">
//         Your payment has been cancelled. Please try again.
//       </CardDescription>
//     </CardHeader>

//     <CardContent className="flex justify-center">
//       <Link
//         to="/billing"
//         className={cn(buttonVariants({ variant: "default" }))}
//       >
//         View Billing Details
//       </Link>
//     </CardContent>
//   </Card>
// </div>
